<template>
  <div class="container page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main" style="padding-top: 54px;">

      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :loading-text="$t('加载中')" :pulling-text="$t('下拉即可刷新')"
        :loosing-text="$t('释放即可刷新')">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="lottery_info">
            <van-image class="cover" src="/img/error.png"></van-image>
            <span class="period-number">{{ v.expect }}</span>
            <!-- <span class="period-number">{{v.name}}</span> -->
          </div>
          <div class="recent">
            <div class="kuaisan-ball left">
              <div>
                <span>{{ $t("reservation.result") }}</span>
                <span class="ressquareBox">{{ size }}</span>
                <span class="ressquareBox">{{ double }}</span>
              </div>

            </div>
          </div>
          <div class="topInfo">

            <span v-if="v.status === 1" style="color: #07c160">{{ v.status_text }}</span>
            <span v-else>{{ v.status_text }}</span>
            <span>{{ $t("reservation.money") }}：{{ v.money }}</span>
          </div>
          <!--   <div class="topInfo">
            <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
            <span v-else >{{v.win_text}}</span>
            <span>金额：{{v.profit}}</span>
          </div> -->
          <!-- <div class="topInfo">
            <span>任务类型：</span>
            <span>{{v.type}}</span>
          </div> -->
          <div class="time">
            <span>{{ $t("reservation.order_time") }}：{{ v.create_time }}</span>
          </div>
          <div class="time">
            <span>{{ $t("reservation.settle_time") }}：{{ v.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      sum: '',
      double: '',
      size: ""
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data;

          this.list.forEach(item => {
            // ******** 仅在这里添加容错修复，其余代码不变 ********
            // 1. 先判断 item.opencode 存在且是数组，否则跳过后续计算（或给默认值）
            if (!item.opencode || !Array.isArray(item.opencode)) {
              return; // 直接跳过当前item，避免报错；也可以给 this.size/this.double 赋值默认值如 '-'
            }
            // 2. 访问索引前，给每个元素加容错，避免数组长度不足3导致 undefined
            const num1 = item.opencode[0] || 0;
            const num2 = item.opencode[1] || 0;
            const num3 = item.opencode[2] || 0;
            // 3. 转成数字类型，避免字符串拼接错误
            this.sum = Number(num1) + Number(num2) + Number(num3);

            if (this.sum >= 11 && this.sum <= 18) {
              this.size = this.$t('玫瑰')
            } else if (this.sum >= 3 && this.sum <= 10) {
              this.size = this.$t('百合')
            }
            if (this.sum % 2 === 0) {
              this.double = this.$t('氣球')
            } else {
              this.double = this.$t('煙花')
            }
          })
          console.log(this.list, 'list')
          console.log(this.size, this.double, 998);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }

  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserGameList();
    }
  },

};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  background: #f2f2f5 url('../../assets/image/bgj.png') no-repeat center top / 100%;
  height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span {
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #FF405D;
}

.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}


.item_list .desc span {
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}

.item_list .cover {
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}

.item_list .period-number {
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 30px;
  font-weight: 700;
  color: #000;
}

.item_list .lottery_info {
  display: flex;
}

.recent {
  display: flex;
  align-items: center;
  height: 100px;
}

.kuaisan-ball .left {
  justify-content: flex-start;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 30px;
}

.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}

.kuaisan-ball .res-des.middle {
  width: 15%;
  font-size: 35px;
}

.ressquareBox {
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #fff;
  height: 7vw;
  line-height: 7vw;
  text-align: center;
  font-size: 3vw;
  font-weight: 700;
  border-radius: 4px;
  margin-left: 20px;
  padding: 13px 40px;
  min-width: 13vw;
}
</style>